import { useSelector } from "react-redux";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import DateRangePicker from "rsuite/DateRangePicker";
import dayjs from "dayjs";
import CustomAccordion from "../controls/CustomAccordion";
import { RootState } from "../../store/store";
import { DateRange } from "../../type/enums";
import { getRangeDate } from "../../utils/helper";
import { useEffect, useState } from "react";
import { DateRange as RSuiteDateRange } from "rsuite/esm/DateRangePicker";

interface DateRangeFilterProps {
  setLocalFilter: React.Dispatch<any>;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  setLocalFilter,
}) => {
  const { selectedFilter } = useSelector((state: RootState) => state.filter);

  //Local filter state
  const [dateRange, setDateRange] = useState<DateRange>(DateRange.YESTERDAY);
  const [[startDate, endDate], setDate] = useState<string[]>(["", ""]);

  useEffect(() => {
    setDateRange(selectedFilter.dateRange);
    setDate([selectedFilter.startDate, selectedFilter.endDate]);
  }, [
    selectedFilter.dateRange,
    selectedFilter.startDate,
    selectedFilter.endDate,
  ]);

  const handleDateRangeChange = (e: SelectChangeEvent) => {
    const value = e.target.value as DateRange;
    const [start, end] = getRangeDate(value);
    setDateRange(value);
    setDate([start, end]);
    if (setLocalFilter && value !== "custom")
      setLocalFilter((prev: any) => ({
        ...prev,
        dateRange: value,
        dateRangeText: value,
        startDate: start,
        endDate: end,
      }));
  };

  const customDateOnChange = (value: RSuiteDateRange | null) => {
    let [start, end] = ["", ""];
    if (value)
      [start, end] = [
        dayjs(value[0]).format("YYYY-MM-DD"),
        dayjs(value[1]).format("YYYY-MM-DD"),
      ];
    if (end < start || (end === "" && start === "")) {
      setLocalFilter((prev: any) => ({
        ...prev,
        startDate: "",
        endDate: "",
      }));
      setDate([start, end]);
      return;
    }
    setDate([start, end]);
    setLocalFilter((prev: any) => ({
      ...prev,
      dateRange: "custom",
      dateRangeText: "custom",
      startDate: start,
      endDate: end,
    }));
  };

  return (
    <CustomAccordion title="Date Range">
      <Stack direction="column" gap={1}>
        <FormControl fullWidth>
          <Select
            value={dateRange || ""}
            onChange={handleDateRangeChange}
            displayEmpty
          >
            <MenuItem value="">Select Date Range</MenuItem>
            <MenuItem value={DateRange.YESTERDAY}>Yesterday</MenuItem>
            <MenuItem value={DateRange.LAST_7_DAYS}>Last 7 Days</MenuItem>
            <MenuItem value={DateRange.LAST_14_DAYS}>Last 14 Days</MenuItem>
            <MenuItem value={DateRange.THIS_MONTH}>This Month</MenuItem>
            <MenuItem value={DateRange.PREVIOUS_MONTH}>Previous Month</MenuItem>
            <MenuItem value={DateRange.CUSTOM}>Custom Date Range</MenuItem>
          </Select>
        </FormControl>

        {dateRange === DateRange.CUSTOM && (
          <DateRangePicker
            value={
              startDate && endDate
                ? [new Date(startDate), new Date(endDate)]
                : null
            }
            onChange={customDateOnChange}
            format="dd-MM-yyyy"
            ranges={[]}
            placeholder="Select Date Range"
          />
        )}
      </Stack>
    </CustomAccordion>
  );
};

export default DateRangeFilter;
